import React from 'react'
import dayjs from 'dayjs'
import { Box, Box as MessageContainer } from '@node-space/ui-components'
import { DateFormat } from 'constants/General'
import { PaymentCaseEmail as CaseEmail } from 'types/payments'
import { getExtractedEmailText } from 'utils/utils'

interface PaymentCaseEmailProps {
  paymentCaseEmail: CaseEmail
}

const dateFormat = DateFormat.HH_MM_DD_MMM_YYYY

export const PaymentCaseEmail = ({ paymentCaseEmail }: PaymentCaseEmailProps) => {
  return (
    <Box
      flex
      width="full"
      className={`${paymentCaseEmail?.incoming ? 'justify-end' : 'justify-start'}`}
    >
      <Box flex flexCol gapY={4} className="w-full max-w-[calc(100%-20px)]">
        <p
          className={`text-body-regular-small text-foreground-subdued ${paymentCaseEmail?.incoming ? 'text-right' : 'text-left'}`}
        >
          {dayjs(paymentCaseEmail?.createdDate).format(dateFormat)}
        </p>
        <p
          className={`text-body-regular text-foreground-faint  ${paymentCaseEmail?.incoming ? 'text-right' : 'text-left'}`}
        >
          {paymentCaseEmail?.fromAddress}
        </p>
        <MessageContainer
          className={`${paymentCaseEmail?.incoming ? 'bg-surface-status-info' : 'bg-surface-interactive-disabled'}`}
          borderRadius={4}
        >
          <p className="text-sm text-foreground-prominent p-3 whitespace-pre-line break-all">
            {getExtractedEmailText(paymentCaseEmail?.textBody)}
          </p>
        </MessageContainer>
      </Box>
    </Box>
  )
}
